import { useEffect, useRef } from "react";

export default function ProductSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.15 }
    );
    const els = sectionRef.current?.querySelectorAll(".fade-up");
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="urun-nedir" ref={sectionRef} className="py-24 md:py-32 bg-white">
      <style>{`
        .fade-up { opacity: 0; transform: translateY(28px); transition: opacity 0.7s ease, transform 0.7s ease; }
        .fade-up.animate-in { opacity: 1; transform: translateY(0); }
        .fade-up:nth-child(2) { transition-delay: 0.15s; }
        .fade-up:nth-child(3) { transition-delay: 0.3s; }
      `}</style>

      <div className="max-w-[1200px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left: Image */}
          <div className="fade-up relative">
            <div className="relative overflow-hidden border border-gray-100">
              <img
                src="https://public.readdy.ai/ai/img_res/b6a1f3a1-b281-4122-8bc9-44bfd891318b.png"
                alt="Prefabrike BESS Ünite"
                className="w-full h-[360px] md:h-[460px] object-cover object-center"
              />
              {/* Corner accent */}
              <div className="absolute top-0 left-0 w-12 h-12 border-t-2 border-l-2 border-[#A66A3F]" />
              <div className="absolute bottom-0 right-0 w-12 h-12 border-b-2 border-r-2 border-[#A66A3F]" />
            </div>
          </div>

          {/* Right: Text */}
          <div>
            <div className="fade-up">
              <span className="inline-block text-[#A66A3F] text-xs font-semibold tracking-[0.2em] uppercase mb-4">
                Ürün Tanımı
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-[#2B2B2B] leading-tight mb-6">
                Prefabrike Enerji<br />Depolama Nedir?
              </h2>
              <div className="w-10 h-0.5 bg-[#A66A3F] mb-8" />
            </div>

            <div className="fade-up">
              <p className="text-[#4A4A4A] text-base leading-[1.85] mb-6">
                Lityum bazlı batarya modüllerinin, PCS, HVAC, yangın ve güvenlik sistemleri ile birlikte izole prefabrik yapı içinde entegre edilmesidir.
              </p>
              <p className="text-[#4A4A4A] text-base leading-[1.85] mb-10">
                Sahada hızlı kurulum ve yüksek verimli enerji altyapısı sağlar. Tüm sistemler fabrikada test edilerek teslim edilir; saha montaj süresi minimum düzeyde tutulur.
              </p>

              {/* Feature list */}
              <div className="space-y-4 mb-12">
                {[
                  "Fabrikada entegre edilmiş tam sistem",
                  "Sahada plug-and-play kurulum",
                  "IEC 62619 & UL 9540 sertifikalı",
                  "Uzaktan izleme ve SCADA entegrasyonu",
                ].map((item) => (
                  <div key={item} className="flex items-start gap-3">
                    <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <div className="w-1.5 h-1.5 bg-[#A66A3F] rounded-full" />
                    </div>
                    <span className="text-sm text-[#4A4A4A]">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Big accent text */}
            <div className="fade-up border-t border-gray-100 pt-8">
              <p className="text-4xl md:text-5xl font-bold text-[#F0F0F0] leading-none select-none" aria-hidden="true">
                Standartların
              </p>
              <p className="text-4xl md:text-5xl font-bold text-[#2B2B2B] leading-none -mt-2">
                dışında çözümler
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
